import React from 'react';
import { Container } from '@mui/material';
import CircularProgressIcon from '@mui/material/CircularProgress';

interface ContainerSpinnerProps {
  height?: number | string;
}

const ContainerSpinner: React.FC<ContainerSpinnerProps> = ({ height }) => (
  <Container
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: height || 'unset'
    }}
  >
    <CircularProgressIcon sx={{ width: '100px !important', height: '100px !important', mb: '33%' }} />
  </Container>
);

export default ContainerSpinner;
